import { useState } from 'react';
import {
  IconButton, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions, Button, TextField,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch, useSelector } from 'react-redux';
import { setTotalPoints, deletePlayer } from 'redux/slices';

export function AdminPlayerMenu({ playerId }) {
  const dispatch = useDispatch();
  const player = useSelector((state) => state.players.find((p) => p.playerId === playerId));
  const currentPoints = player?.totalPoints ?? ((player?.wins || 0) - (player?.losses || 0));

  const [anchorEl, setAnchorEl] = useState(null);
  const [pointsOpen, setPointsOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [pointsValue, setPointsValue] = useState(currentPoints);

  const closeMenu = () => setAnchorEl(null);

  const openPoints = () => {
    setPointsValue(currentPoints);
    setPointsOpen(true);
    closeMenu();
  };

  const savePoints = () => {
    dispatch(setTotalPoints({ playerId, totalPoints: Number(pointsValue) }));
    setPointsOpen(false);
  };

  const confirmDelete = () => {
    dispatch(deletePlayer(playerId));
    setDeleteOpen(false);
  };

  return (
    <>
      <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        <MenuItem onClick={openPoints}>Atualizar pontos</MenuItem>
        <MenuItem onClick={() => { setDeleteOpen(true); closeMenu(); }}>Deletar jogador</MenuItem>
      </Menu>

      <Dialog open={pointsOpen} onClose={() => setPointsOpen(false)}>
        <DialogTitle>Atualizar pontos</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 1 }}>
            {player?.playerName}
          </DialogContentText>
          <TextField
            type="number"
            label="Pontos (0 a 100)"
            value={pointsValue}
            onChange={(e) => setPointsValue(e.target.value)}
            inputProps={{ min: 0, max: 100 }}
            autoFocus
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPointsOpen(false)}>Cancelar</Button>
          <Button variant="contained" onClick={savePoints}>Salvar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogTitle>Deletar jogador</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Tem certeza que deseja deletar ${player?.playerName}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)}>Cancelar</Button>
          <Button color="error" variant="contained" onClick={confirmDelete}>Deletar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
